<template>
  <div class="document-style">
    <ul class="fs-16">
      <li>
        <div class="title-list-style">
          <span>Activity Overview</span>
        </div>
        <div>
          <div class="mt-6">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Last 30 days updated in
            real-time
          </div>
        </div>
        <div class="mt-24">
          <div class="fw-700">Manager Activity</div>
        </div>
        <div class="note-box">
          <div class="fw-700 mb-6">Open insight</div>
          <div class="flex-center">
            <img
              :src="$utils('icons', 'User_status_Active_24px')"
              class="mr-6"
              alt="icons_User_status_Active_24px"
            />
            : Frequently reply to feedback.
          </div>
          <div class="flex-center mt-4">
            <img
              :src="$utils('icons', 'User_status_Passive_24px')"
              class="mr-6"
              alt="icons_User_status_Passive_24px"
            />
            : Sometimes reply to feedback.
          </div>
          <div class="flex-center mt-4">
            <img
              :src="$utils('icons', 'User_status_Inactive_24px')"
              class="mr-6"
              alt="icons_User_status_Inactive_24px"
            />
            : Reply to feedback below standard.
          </div>
          <div class="mt-12">
            <span class="fw-700">Proactivity Rating:</span>
            <span class="ml-6">
              A measure of how well managers control a situation by causing
              something to happen rather than responding to it after it has
              happened.
            </span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Psychological Safety Rating:</span>
            <span class="ml-6">
              A measure of being able to express oneself without fear of
              negative consequences or a shared belief that the team is safe for
              interpersonal risk taking.
            </span>
          </div>
        </div>
        <div class="mt-24">
          <div class="fw-700">Manager Activity</div>
        </div>
        <div class="note-box">
          <div class="fw-700">Open-ended Feedback</div>
          <div>
            The percent of people who answer daily open-ended questions in the
            past 30 days
          </div>
          <div class="mt-12">
            <span class="fw-700">Reply Rate:</span>
            <span class="ml-6">
              Percentage of responses to feedback from team members
            </span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Reply Quality:</span>
            <span class="ml-6">
              Percentage of giving gems as recognition to team members
            </span>
          </div>
        </div>
        <div class="mt-24">
          <div class="fw-700">Insights & Nudges</div>
        </div>
        <div class="note-box">
          <div class="fw-700">Daily Insights Opened:</div>
          <div>Percentage of daily insights opened by managers</div>
          <div class="mt-12">
            <span class="fw-700">Weekly Insight Opened:</span>
            <span class="ml-6">
              Percentage of weekly insights opened by managers
            </span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Nudges:</span>
            <span class="ml-6">
              The number of nudges sent, click to see all nudges
            </span>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>By Manager</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This graph shows manager
              engagement, measured from insight opening and feedback reply rate.
            </div>
          </div>
          <div class="mt-24">
            <div class="fw-700">Chart</div>
          </div>
          <div>
            Managers activity in opening insights and replying to team feedback
            over the past 30-days
          </div>
          <div class="note-box">
            <div class="flex-center">
              <div
                class="fs-2 mr-6"
                style="
                  width: 16px;
                  height: 16px;
                  border-radius: 16px;
                  background-color: #35d077;
                "
              >
                &nbsp;
              </div>
              Green : Active
            </div>
            <div class="flex-center mt-4">
              <div
                class="fs-2 mr-6"
                style="
                  width: 16px;
                  height: 16px;
                  border-radius: 16px;
                  background-color: #fbc02d;
                "
              >
                &nbsp;
              </div>
              Yellow : Passive
            </div>
            <div class="flex-center mt-4">
              <div
                class="fs-2 mr-6"
                style="
                  width: 16px;
                  height: 16px;
                  border-radius: 16px;
                  background-color: #f44336;
                "
              >
                &nbsp;
              </div>
              Red : Inactive
            </div>
            <div>The size of the circles represents the size of a team.</div>
          </div>
          <div class="mt-24">
            <div class="fw-700">Table</div>
          </div>
          <div>
            All of the managers’ names with their engagement status and the team
            challenge they face. (not manager’s problem areas)
          </div>

          <div class="note-box">
            <div>Critical Areas is ??????</div>
            <div>#????</div>
          </div>

          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              You can see <span class="fw-700">Coaching Progress</span> view by click the green , yellow ,
              or red wrench icon. Modal will show the challenges’ status and
              details.
            </span>
            <div class="flex mt-4">
              <img
                :src="$utils('icons', 'fix_circle_green_24')"
                alt="icons_fix_circle_green_24"
                class="mr-8"
              />
              <img
                :src="$utils('icons', 'fix_circle_yellow_24')"
                alt="icons_fix_circle_yellow_24"
                class="mr-8"
              />
              <img
                :src="$utils('icons', 'fix_circle_red_24')"
                alt="icons_fix_circle_red_24"
              />
            </div>
          </div>
          <div class="mt-24">
            <div class="fw-700">Coaching Progress</div>
          </div>
          <div>
            The teams that face problems in one of the three dimensions:
            Personal Growth, Feedback, and Recognition, for more than two weeks
            in a row; will receive an email regarding their problem, its
            importance, and suggested solutions.
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
      
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script><style lang="scss" scoped></style>